import React, { useContext, useEffect, useState } from 'react'
import styled from 'styled-components';
import Logo from 'components/Gui/Logo';
import { BookLayoutContext } from 'contexts/BookLayoutContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import ModelInfo from 'components/Model/ModelInfo';
import PlaylistsNav from 'components/Model/PlaylistsNav';
import { playlistItemsLength } from 'utils/modelPlaylists';
import useDimensions from 'react-cool-dimensions';

const HeaderWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: ${props => props.$headerHeight};
  border-bottom: 1px solid ${props => props.theme.BorderColor};
  padding: 0;
  z-index: 80;
  background-color: ${props => props.theme.LayoutBodyBackground};

  .header-left {
    flex: 0 0 0;
    border-right: 1px solid ${props => props.theme.BorderColor};
    padding: 0 3rem;
    height: ${props => props.$headerHeight};
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
  
  .header-middle {
    flex: 1 1 0;
    height: ${props => props.$headerHeight};
    padding: .5rem .5rem .25rem 1.5rem;
    width: 100%;
    position: relative;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: flex-start;
  }

  .header-right {
    flex: 0 1 1;
    min-width: ${props => (props.$siderOpen ? `${props.$siderWidth}px` : '6rem')};
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-end;
    padding-right: 3rem;
    
    .package-sider-trigger {
      font-size: 1.75rem;
      cursor: pointer;
    }
  }
`

const NwBookHeader = ({ model }) => {
    const { siderOpen, toggleSider, siderWidth, siderAsDrawer, headerHeight, windowWidth, modelInfoExtended } = useContext(BookLayoutContext)
    const [compact, setCompact] = useState(false)
    const { observe, width } = useDimensions()
    
    
    useEffect(() => {
        let navtextlength = playlistItemsLength(model ? model.Playlists : [])
        let navitemslength = model ? model.Playlists.length : 0
        if (model && model.Note && model.Note.length > 0) {
            navitemslength += 1
            navtextlength += 8
        }
        const dividerWidth = 21
        const letterWidth = 8
        const navWidth = (navtextlength * letterWidth) + ((navitemslength - 1) * dividerWidth)
        setCompact(navWidth > width)
    }, [model, width])

    const showPackageSiderTrigger = () => {
        if (windowWidth < 768) {
            return false
        }
        return true
    }

    

    return (
        <HeaderWrapper
            $siderOpen={siderOpen && !siderAsDrawer}
            $siderWidth={siderWidth}
            $headerHeight={`${headerHeight}px`}
            $hasTwoLines={modelInfoExtended}
            $compact={compact}
        >
            <div className="header-left">
                <Logo />
            </div>
            <div className="header-middle" ref={observe}>
                {model &&
                    <>
                        <ModelInfo compact={compact} model={model} />
                        <PlaylistsNav compact={compact} model={model} />
                    </>
                }
            </div>
            {showPackageSiderTrigger() &&
                <div className="header-right">
                    <div className='package-sider-trigger' onClick={toggleSider}>
                        <FontAwesomeIcon icon={light("bars-staggered")} />
                    </div>
                </div>
            }
        </HeaderWrapper>
    )
}

export default NwBookHeader

